import { useNavigate } from 'react-router-dom'
import FixHeader from '../component/FixHeader'
import Footer from '../component/Footer'
import Loader from '../component/Loader'

const Contact = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Contact Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="about-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Contact Us</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/")}>Contact Us</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Contact Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container overflow-hidden">
                    <h2 className="d-none">hidden</h2>
                    <div className="row contact-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                            <div className="form-inquiry">
                                <input type="text" className="form__input" placeholder="Name*" id="name" required=""
                                    autoComplete="off" name='name' />
                            </div>
                            <div className="form-inquiry">
                                <input type="text" className="form__input" placeholder="Email*" id="name2" required=""
                                    autoComplete="off" name='name2' />
                            </div>
                            <div className="form-inquiry">
                                <input type="text" className="form__input" placeholder="Subject*" id="name3" required=""
                                    autoComplete="off" name='name3' />
                            </div>
                            <div className="form-inquiry">
                                <textarea className="form__input" placeholder="Messages*" id="subject" required=""
                                    autoComplete="off"></textarea>
                            </div>
                            <div className="remember-main">
                                <div className="remember m-0">
                                    <input type="checkbox" name="check" />
                                    <p>I agree that my submitted data is being collected and stored.*</p>
                                </div>
                            </div>
                            <div className="form-btn">
                                <div className="button button404" data-text="Submit Now">
                                    <span>Submit Now</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 map-iframe-main">
                            <iframe className="map-iframe"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11661.278162829134!2d-76.16113884753138!3d43.0557465765357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d9f3add89232d3%3A0x516c4febad79a023!2sNear%20Northeast%2C%20Syracuse%2C%20NY%2013203%2C%20USA!5e0!3m2!1sen!2sin!4v1704092010021!5m2!1sen!2sin"
                                allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map">
                            </iframe>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== About Section Five ===================================== --> */}
            <section className="about-section-five">
                <div className="container">
                    <h2 className="section-heading-text best-solutions" data-aos="fade-up">Trust Me to deliver the <span>best
                        solutions</span> tailored to your needs.</h2>
                    <p className="sitamet-text nemo-text" data-aos="fade-up">Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Temporibus, iusto, quia neque amet saepe?</p>
                    <div className="subscribe-input-main" data-aos="fade-up">
                        <input type="text" placeholder="Enter Your Email" name='EntEmail' />
                        <div className="button btn-subscribe" data-text="Subscribe">
                            <span>Subscribe</span>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Contact